module.exports = __webpack_public_path__ + "static/img/ID.1ffdce3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/userTips/ID.png
// module id = Uf+v
// module chunks = 1